import { getenv } from '~/settings'

export const SALES_EMAIL = getenv('REGIONAL_CONFIGS')?.emails?.sales
export const PRODUCTION_EMAIL = getenv('REGIONAL_CONFIGS')?.emails?.production
export const HELP_EMAIL = getenv('REGIONAL_CONFIGS')?.emails?.help
